<template>
	<div class="recipients-section pt-3">
		<div class="container">
			<div class="row">
				<div class="col-12">
					<h2 class="mb-5">
						Obsługujemy
					</h2>
				</div>
			</div>
			<div class="recipients row justify-content-between">
				<div class="recipients__item col-12 col-lg-3 d-flex align-items-start mb-3 mb-lg-0" v-for="recipient in recipients" :key="recipient.id">
					<div class="recipients__icon">
						<img :src="recipient.icon" alt="" class="d-inline-block mr-3">
					</div>
					<h4 class="recipients__content" v-html="recipient.name"></h4>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		name: 'Recipients',
		data() {
			return {
				recipients: [
					{
						icon: 'assets/images/house.svg',
						name: 'Domy <br>jednorodzinne'
					},
					{
						icon: 'assets/images/block.svg',
						name: 'Osiedla <br>mieszkaniowe'
					},
					{
						icon: 'assets/images/commercial.svg',
						name: 'Obiekty <br>komercyjne'
					},
				]
			}
		}
	}
</script>